'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var FieldRequiredIndicator = require('../alloy-input/FieldRequiredIndicator.js');
var SingleItemDropdown = require('./SingleItemDropdown.js');
var MultiItemDropdown = require('./MultiItemDropdown.js');

var DEFAULT_ITEM_TO_STRING = function (val) {
    if (val === void 0) { val = ''; }
    return (val ? val : '');
};
var DEFAULT_TITLE_TO_STRING = function () { return ''; };
var Dropdown = function (_a) {
    var error = _a.error, items = _a.items, _b = _a.itemToString, itemToString = _b === void 0 ? DEFAULT_ITEM_TO_STRING : _b, _c = _a.keyToString, keyToString = _c === void 0 ? DEFAULT_ITEM_TO_STRING : _c, _d = _a.titleToString, titleToString = _d === void 0 ? DEFAULT_TITLE_TO_STRING : _d, label = _a.label, onChange = _a.onChange, name = _a.name, _e = _a.selected, selected = _e === void 0 ? '' : _e, setError = _a.setError, showOptional = _a.showOptional, showRequired = _a.showRequired, id = _a.id, props = tslib.__rest(_a, ["error", "items", "itemToString", "keyToString", "titleToString", "label", "onChange", "name", "selected", "setError", "showOptional", "showRequired", "id"]);
    var _f = useDefaultInternalState.default(selected, onChange), internalSelected = _f[0], internalOnChange = _f[1];
    var _g = useDefaultInternalState.default(error, setError), internalError = _g[0], setInternalError = _g[1];
    // To help prevent infinite loops, internalOnChange is assigned to ref.current here. This will
    // ensure that when it's used in a useEffect it doesn't trigger extra rerenders.
    var internalOnChangeRef = react.useRef(null);
    internalOnChangeRef.current = internalOnChange;
    var isSingleChoice = items.length === 1;
    var singleChoiceSignature = isSingleChoice ? JSON.stringify(items[0]) : '';
    // If there's only 1 item available and selected was not passed down then automatically select it. Uses 'singleChoiceSignature' to force
    // a deep compare of items - otherwise infinite loop occurrs in some circumstances
    react.useEffect(function () {
        if (isSingleChoice && !selected) {
            var newSingleChoice = JSON.parse(singleChoiceSignature);
            internalOnChangeRef.current(newSingleChoice);
        }
    }, [isSingleChoice, singleChoiceSignature, selected]);
    var getLabel = function () {
        return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [label, (showRequired || showOptional) && (jsxRuntime.jsx(FieldRequiredIndicator.default, { showOptional: showOptional, showRequired: showRequired }))] }));
    };
    return isSingleChoice ? (jsxRuntime.jsx(SingleItemDropdown.default, tslib.__assign({ getLabel: getLabel, id: id, internalError: internalError, items: items, itemToString: itemToString, name: name, setError: setInternalError, setValue: onChange }, props))) : (jsxRuntime.jsx(MultiItemDropdown.default, tslib.__assign({ error: error, getLabel: getLabel, id: id, internalError: internalError, internalOnChange: internalOnChange, internalSelected: internalSelected, items: items, itemToString: itemToString, keyToString: keyToString, titleToString: titleToString, label: label, name: name, setInternalError: setInternalError }, props)));
};
var JsDropdown = Dropdown;

exports.default = JsDropdown;
//# sourceMappingURL=Dropdown.js.map
